import { httpGet } from '../../../../components/utils';
import { ACCESS_ANALYSIS_BASE_URL } from '../consts';

type ResourceDto = {
    name: string;
    resource_id: string;
    stale_after?: number;
    type: string;
};

export type ApplicationResource = {
    name: string;
    resource_id: string;
    stale_after?: number;
    type: 'hostname' | 'ip';
};

export type ApplicationResourcesDto = {
    data: Array<ResourceDto>;
};

const mapResponse = (resource: ResourceDto): ApplicationResource => ({
    ...resource,
    type: resource.type as 'hostname' | 'ip'
});

export const getApplicationResources = async (id: string) => {
    const url = `${ACCESS_ANALYSIS_BASE_URL}/applications/${id}/resources`;

    try {
        const { data } = await httpGet(url);

        const response = data as unknown as ApplicationResourcesDto;

        return response && response.data ? response.data.map(mapResponse) : [];
    } catch (err: unknown) {
        console.log(`An error occurred while fetching application resources: ${err}`);

        return null;
    }
};
